var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
export default createStyles(function (_ref) {
  var css = _ref.css;
  return {
    progressModalContainer: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      width: 680px !important;\n    "]))),
    progressBarContainer: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-top: 32px;\n    "])))
  };
});